/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {Oktoberfest} from "../../Oktoberfest";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OktoberfestParsedGameData} from "../../server/data/OktoberfestParsedGameData";
import {OktoberfestParsedInitData} from "../../server/data/OktoberfestParsedInitData";

export class ScatterLandingController extends ReelStopPresentationController {
    protected _scatterCounter:number;
    private _animations:TimelineLite[] = [];

    constructor() {
        super("ScatterLandingController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const scatterPosition = Oktoberfest.model.parsedGameData.scatterPositions![data.reelId];
        if(scatterPosition === -1) {
            return Promise.resolve();
        }

        this._scatterCounter += 1; // To change if more scatter on the one reel.

        // When there is not enough reel left to win.
        if(!this.isPossibleToWin(data.reelId)) {
            // also cut off the ongoing animations in previous reels.
            this._animations.forEach(a => a.progress(1));
            return Promise.resolve();
        }

        return Promise.resolve(this.playAttentionAnimation(data.reelId, scatterPosition));
    }

    // override in different scatter winning rules.
    private isPossibleToWin(reelId: number): boolean {
        let flag: boolean;
        const parsedData: OktoberfestParsedInitData | OktoberfestParsedGameData = Oktoberfest.model.parsedGameData ? Oktoberfest.model.parsedGameData : Oktoberfest.model.parsedInitData;

        if (reelId === 0 && this._scatterCounter === 1) {
            flag = true;
        } else if (reelId === 2 && this._scatterCounter === 2) {
            flag = true;
        } else if (reelId === 4 && this._scatterCounter === 3) {
            flag = true;
        } else {
            flag = false;
        }

        if (parsedData.mode === GameMode.FREESPIN || parsedData.nextMode === GameMode.FREESPIN) {
            flag = true;
        }

        return flag;
    }

    private playAttentionAnimation(reelId: number, symId: number): Promise<any> {
        const tl: TimelineLite = new TimelineLite(),
            symbol = Oktoberfest.reels[reelId].getSymbol(symId),
            parsedData: OktoberfestParsedInitData | OktoberfestParsedGameData = Oktoberfest.model.parsedGameData ? Oktoberfest.model.parsedGameData : Oktoberfest.model.parsedInitData;

        tl.add(() => {
            symbol.playLanding()
        }, 0.01);

        if (reelId === 4 && (parsedData.mode === GameMode.NORMAL && parsedData.nextMode === GameMode.FREESPIN)) {
            Oktoberfest.model.parsedGameData.scatterPositions!.forEach((currSymId, currReelId) => {
                if (currSymId > -1 && currReelId !== 4) {
                    const prevSymbol = Oktoberfest.reels[currReelId].getSymbol(currSymId);
                    const symTl = new TimelineLite();
                    symTl.add(prevSymbol.playLanding());
                    tl.add(symTl, 0.01);
                }
            });
        }

        this._animations.push(tl);
        return Promise.resolve(tl).then(res => {
            ArrayHelper.removeFirstMatchElement(this._animations, tl);
        });
    }

    protected reset() {
        super.reset();
        this._scatterCounter = 0;
    }
}